<template>
  <div class="Login">
    <van-nav-bar title="" fixed bord>
		<template #left>
			<van-icon name="wap-home-o" size="20px" @click="onClickLeft" />
		</template>
    </van-nav-bar>

    <div class="login-img">
      <img src="../assets/logo.png" width="100" height="100" alt />
      <div>欢迎登录</div>
    </div>
    <van-row class="van-row" type="flex" justify="center">
      <van-cell-group>
        <van-field
          v-model="params.loginID"
          left-icon="user-o"
          clearable
          border
          label
          placeholder="请输入手机号 / 账号"
        >
          <template slot="left-icon">
            <img src="../assets/img/login/user.png" class="icon" />
          </template>
        </van-field>
        <van-field
          v-model="params.password"
          type="password"
          left-icon="bag-o"
          label
          placeholder="请输入密码"
          clearable
        >
          <template slot="left-icon">
            <img src="../assets/img/login/code.png" class="icon" />
          </template>
        </van-field>

        <van-field
          class="vercode"
          v-model="params.captcha"
          clearable
          left-icon="bag-o"
          label
          placeholder="请输入验证码"
        >
          <template slot="left-icon">
            <img src="../assets/img/login/password.png" class="icon" />
          </template>
          <img class="codeImg" slot="right-icon" :src="imgCode" alt="验证码" @click="changeImgCode" />
        </van-field>
      </van-cell-group>
    </van-row>
    <div class="login-btn-box">
      <van-button block @click="onSubmit()" :disabled="isDisable">登录</van-button>
    </div>
    <div class="login-wechat" @click="wxHandLogin" v-if="wxConfigs.appid">
      <img src="../assets/img/icon/wechat.png" class="icon" />微信登录
    </div>
    <div class="routerReg" :style="{'margin-top': '10%'}">
      <!-- <span class="forgetm" @click="toService()">忘记密码</span> -->
      没有账号？
      <span class="regist" @click="toRegist">立即注册</span>
    </div>
    <div class="app_download" v-if="platforms!='app'&&showAppDownload">
      <div class="container">
        <img class="logo" src="../assets/logo.png" />
        <div class="note">
          <div class="site_name" v-text="siteTitle"></div>手机APP，更便捷高效体验！
        </div>
        <div class="btn_download" @click="tapDownload()">立即下载</div>
        <div class="close" @click="showAppDownload=!showAppDownload">X</div>
      </div>
    </div>
		<van-popup v-model="showQRCodeUrl" position="bottom" :style="{ 'max-height': '80%' ,'text-align':'center','padding-bottom':(platforms!='app'&&showAppDownload)?'50px':'10px'}">
			<van-cell-group title="微信扫一扫登录" class="pay_type_group">
				<vue-qr :text="QRCodeUrl" :size="220"></vue-qr>
				<br>
				<van-button
				  class="btn"
				  v-clipboard:copy="QRCodeUrl"
				  v-clipboard:success="onCopy"
				  v-clipboard:error="onError"
				>复制链接至微信打开</van-button>
			</van-cell-group>
		</van-popup>
  </div>
  
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import md5 from "js-md5";
import vueQr from "vue-qr";
import {chkAndroidOrios,chkWeiXin,compWxAuthUrl} from "@/utils/common.js";

export default {
	name: "Login",
	components: {
		"vue-qr":vueQr
	},
	data() {
		return {
			siteTitle:top._SHARE_INFO.title,
			wxConfigs:{},
			params: {
				loginID: "",
				password: "",
				captcha: "",
			},
			imgCode:'',//this.Conf.serverUrl + "Verify/getVerify" + "?num=" + Math.random(), // 获取验证码
			winH: null,
			showAppDownload: true,
			platforms: null,
			isDisable: false,
			device_type: "",
			userInfo: [],
			showQRCodeUrl:false,
			QRCodeUrl:'',
			chkWebsocketTimer:false,
			prePath:localStorage.getItem("before_path")
		};
	},
	created(){
		this.chkLogined();
		this.getCaptcha();
		this.getStateWxConfigs();
	},
	methods: {
		onClickLeft() {
			this.$router.push({ path: this.Conf.homeUrl });
		},
		chkLogined(){
			if(localStorage.getItem("u_id") && localStorage.getItem(localStorage.getItem("u_id") + "token")){
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "已有登录信息，确认退出？",
				})
				.then(() => {
					var url = this.Conf.serverUrl + "User/logOut" + "?num=" + Math.random();
					var data = {
						u_id: localStorage.getItem("u_id"),
						token: localStorage.getItem(localStorage.getItem("u_id") + "token")
					};
					this.$axios.post(url, this.$qs.stringify(data))
					.then(response => {
						switch (response.data.code) {
							case 200:
								window.localStorage.clear();
								break;
							case 40001:
								this.$toast.fail(response.data.msg);
								break;
						}
					})
					.catch(error => {
					});
				})
				.catch((error) => {
					if(localStorage.getItem("before_path")){
						this.$router.push({ path: localStorage.getItem("before_path") });
					}else{
						this.$router.push({ path: this.Conf.homeUrl });
					}
					
				});
			}
		},
		getStateWxConfigs(){
			const confs = this.$store.state.common.wx_mp;
			if(confs){
				this.wxConfigs = confs
			}else{
				setTimeout(() => {
					this.getStateWxConfigs();
				},1000);
			}
		},
		getCaptcha(){
			let url = this.Conf.serverUrl + "Verify/getVerify" + "?num=" + Math.random(); // 获取验证码
			this.$axios
			.post(url, this.$qs.stringify({}))
			.then((response) => {
				this.imgCode = response.data;
			})
			.catch((error) => {
			});
		},
		onSubmit() {
			this.isDisable = true;
			if (chkAndroidOrios()) {
				this.device_type == 2; //安卓
			} else {
				this.device_type == 1; //ios
			}
			var url = this.Conf.serverUrl + "Login/index" + "?num=" + Math.random();
			var data = {
				loginID: this.params.loginID,
				password: md5(this.params.password),
				captcha: this.params.captcha,
				device_type: this.device_type,
			};
			this.$axios
			.post(url, this.$qs.stringify(data))
			.then((response) => {
				this.isDisable = false;
				switch (response.data.code) {
					case 200:
						this.loginSuccess(response.data);
						break;
					case 40001:
						this.$toast.fail(response.data.msg);
						this.changeImgCode();
						break;
				  }
				})
			.catch((error) => {
			});
		},
		loginSuccess(data){
			this.$toast.success(data.msg);
			// 保存服务端返回的token、用户id
			localStorage.setItem(
				data.u_id + "token",
				data.token
			);
			localStorage.setItem("u_id", data.u_id);
			if (data.userInfo) {
				localStorage.setItem( "userInfo", JSON.stringify(data.userInfo) );
			}
			try{
				// 绑定通讯用户信息
				if ((this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1) ) {
					this.websocket.ws.send(JSON.stringify({
						mk:200,
						uid:data.u_id,
						token:data.token,
						rndid:this.$store.state.common.rndid
					}));
				}
				localStorage.removeItem("inviter_code");
			}catch(e){}
			// 登录成功跳转到首页
			if(this.prePath && this.prePath!='null'){
				localStorage.removeItem("before_path");
				this.$router.push({ path: this.prePath });
			}else{
				this.$router.push({ path: this.Conf.homeUrl });
			}
		},
		// 点击验证码图片修改图片src 刷新
		changeImgCode() {
			this.getCaptcha();
			//this.imgCode = this.Conf.serverUrl + "Verify/getVerify?" + Math.random();
		},
		toRegist() {
			this.$router.push({ path: "/Regist" });
		},
		tapDownload() {
			window.open("/h5/");
		},
		wxHandLogin() {
			if(!this.wxConfigs.appid) return;
		
			let states = {
				'_f':'m',
				'_id':this.$store.state.common.rndid,
				'_code':localStorage.getItem("inviter_code")||"",
				'_type':chkAndroidOrios()?2:1
			};
			if(chkWeiXin()){
				states['_f'] = 'wx';
				window.location.href = compWxAuthUrl(this.wxConfigs, states);
			}else{
				this.QRCodeUrl = compWxAuthUrl(this.wxConfigs, states);
				this.showQRCodeUrl = true;
			}

		},	
		// 复制成功
		onCopy(e) {
			this.$toast("复制成功,请在微信内打开！");
		},
		// 复制失败
		onError(e) {
			this.$toast("复制失败,稍后请重试！");
		}
	},
	mounted() {
		this.platforms = this.Conf.platform;
	},
};
</script>

<style scoped>
	.van-nav-bar{
		background-color:transparent !important;
	}
	.van-hairline--bottom::after {
		border-bottom-width:0px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue